import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
	OfferTerm,
	OfferTermMaxRooms,
	ProductRoomAvailability,
	ProductRoomsAvailabilities,
} from '../bag-transport-term.model';

@Injectable({
	providedIn: 'root',
})
export class BagTransportTermChangeRoomAvailabilityApiService {
	private readonly httpClient = inject(HttpClient);

	productAvailableRooms(productId: number, termId: number): Observable<ProductRoomsAvailabilities> {
		return this.httpClient.get<ProductRoomsAvailabilities>(
			`${environment.apiUrl}/product/${productId}/count_room_types/?term=${termId}`,
		);
	}

	changeProductAvailableRooms(productId: number, data: ProductRoomAvailability): Observable<void> {
		return this.httpClient.post<void>(
			`${environment.apiUrl}/product/${productId}/set_room_type_availability/`,
			data,
		);
	}

	productMaxRooms(termId: number): Observable<OfferTerm> {
		return this.httpClient.get<OfferTerm>(`${environment.apiUrl}/offer/term/${termId}/`);
	}

	changeProductMaxRooms(termId: number, data: OfferTermMaxRooms): Observable<void> {
		return this.httpClient.patch<void>(`${environment.apiUrl}/offer/term/${termId}/`, data);
	}
}
